import { Component, OnInit } from "@angular/core";
import * as highcharts from "highcharts";

@Component({
  selector: "app-area-chart",
  templateUrl: "./area-chart.component.html",
  styleUrls: ["./area-chart.component.scss"],
})
export class AreaChartComponent implements OnInit {
  highcharts =highcharts
  chartOptions = {};
  constructor() {}

  ngOnInit(): void {
    this.plotchart()
  }
  plotchart() {
    this.chartOptions = {
      chart: {
        type: "area",
        backgroundColor:"transparent"
      },
      accessibility: {
        description: "",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        allowDecimals: false,
        labels: {
          // formatter: function () {
          //   return this.value; // clean, unformatted number for year
          // },
        },
        // accessibility: {
        //   rangeDescription: "Range: 1940 to 2018.",
        // },
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          // formatter: function () {
          //   return this.value / 1000 + "k";
          // },
        },
      },
      tooltip: {
        pointFormat:
          "{series.name} had stockpiled <b>{point.y:,.0f}</b><br/>warheads in {point.x}",
      },
      plotOptions: {
        area: {
          stacking: 'normal',
          marker: {
            enabled: false,
            symbol: "circle",
            radius: 2,
            states: {
              hover: {
                enabled: true,
              },
            },
          },
        },
      },
      series: [
        {
          name: "Power Unit/Cabin",
          color:"#09AF99",
          fillOpacity:1,
          opacity:1,
          fillColor: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, '#8BF4E6'],
              [100,'#09AF99']
            ]
          },
          data: [
            {x:"JAN",y:6},
            ["Feb",11],
            ["Mar",30],
            ["Apr",40],
            ["May",45],
          ],
        },
        {
          name: "LNG Unit/Cabin",
          color:"#F28556",
          fillColor: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, '#FFD8C8'],
              [100,'#F28556']
            ]
          },
          data:   [["Jan",16],
          ["Feb",11],
          ["Mar",40],
          ["Apr",50],
          ["May",65],]
        },
      ],
    };
  }
}
